import { SUBSCRIPTION_INTERVAL } from "shared/enums/common.enum";

export class PurchaseTrialedSubscriptionRequestDTO {
    subscriptionId!: string;
    interval!: SUBSCRIPTION_INTERVAL;

    constructor(data: PurchaseTrialedSubscriptionRequestDTO) {
        Object.assign(this, data);
    }
}